import { render } from "./MenuToggleButton.vue?vue&type=template&id=04130b5c&scoped=true"
import script from "./MenuToggleButton.vue?vue&type=script&lang=js"
export * from "./MenuToggleButton.vue?vue&type=script&lang=js"

import "./MenuToggleButton.vue?vue&type=style&index=0&id=04130b5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04130b5c"]])

export default __exports__